import qs from 'qs'

export function stringify(obj: unknown): string {
    return qs.stringify(obj, {
        strictNullHandling: true,
    })
}

export function parse(str: string): ReturnType<typeof qs.parse> {
    return qs.parse(str, {
        strictNullHandling: true,
        decoder: (str, defaultDecoder, charset, type) => {
            if ('value' === type) {
                if ('true' === str) {
                    return true
                }

                if ('false' === str) {
                    return false
                }
            }

            return defaultDecoder(str, defaultDecoder, charset)
        },
    })
}
